"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
var Colors;
(function (Colors) {
    Colors["Blue300"] = "#339BFF";
    Colors["Blue500"] = "#0074E4";
    Colors["Blue600"] = "#2D74DA";
    Colors["Green300"] = "#11CF59";
    Colors["Green500"] = "#00A78F";
    Colors["Green700"] = "#0B873A";
    Colors["Yellow300"] = "#FFCB8F";
    Colors["Yellow500"] = "#FFA640";
    Colors["Yellow700"] = "#DB7C00";
    Colors["Yellow900"] = "#EC6B2D";
    Colors["Red300"] = "#E97780";
    Colors["Red500"] = "#DE3341";
    Colors["Red600"] = "#D32950";
    Colors["Purple300"] = "#9D91CF";
    Colors["Purple500"] = "#CB3C7E";
})(Colors = exports.Colors || (exports.Colors = {}));
//# sourceMappingURL=colors.js.map